import { render, staticRenderFns } from "./add-lockcourse.vue?vue&type=template&id=4be7f6d2&scoped=true&"
import script from "./add-lockcourse.vue?vue&type=script&lang=js&"
export * from "./add-lockcourse.vue?vue&type=script&lang=js&"
import style0 from "./add-lockcourse.vue?vue&type=style&index=0&id=4be7f6d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be7f6d2",
  null
  
)

export default component.exports